import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import ClearFilters from 'src/modules/search/posts/components/clearFilters';
import CommunityFilterOptions from 'src/modules/search/posts/components/communityFilterOptions';
import SearchResults from 'src/modules/search/posts/components/searchResults';
import { ResultsContainer, ResultsContent, ResultsSidebar } from 'styles-js/resultsList';

type Props = {
  isCommunitySearch?: boolean;
  isMemberOfCommunity?: boolean;
}
export default function SearchResultsList({ isCommunitySearch, isMemberOfCommunity }: Props) {
  const isMember = useSelector(({ context }) => Boolean(context.currentUser));
  const { communityFilterOptions } = useSelector(({ pages }) => pages.search);

  if (isCommunitySearch) {
    return (
      <SearchResults isCommunitySearch={isCommunitySearch} isMemberOfCommunity={isMemberOfCommunity} />
    );
  } else {
    return (
      <ResultsContainer>
        <ResultsContent>
          <SearchResults isCommunitySearch={isCommunitySearch} isMemberOfCommunity={isMemberOfCommunity} />
        </ResultsContent>
        <ResultsSidebar>
          <div className="search__sidebar filter-options" data-testid="search-sidebar-filter-options">
            <div className="filter-header">
              <div className="filter-title">{i18n.t('Filter results')}</div>
              <ClearFilters />
            </div>
            <CommunityFilterOptions
              communityFilterOptions={communityFilterOptions}
              isMember={isMember}
            />
          </div>
        </ResultsSidebar>
      </ResultsContainer>
    );
  }
}
